import data from '../translation.json';

export default (path) => data.careers.positions.find(position => position.main.name === path);
